import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import VisibilitySensor from 'react-visibility-sensor';
import '../../index.css';
import { Helmet } from 'react-helmet';
import Auth from '../../services/Auth';
import BBAnalytics from '../../services/BBAnalytics';
import Content from '../../constants/Content';
import Environment from '../../services/Environment';
import MetaTagService from '../../services/MetaTagService';
import CartUtils from '../../services/CartUtils';
import BitsyApollo from '../../services/BitsyApollo';
import SentryService from '../../services/Sentry';

import Home from '../home';

import {
  MyAccount,
  SubscriptionDetails,
  PaymentDetails,
  DueDateCalculator,
  WeekByWeek,
  ThankYou,
  Shop,
  Faq,
  About,
  BumpFund,
  Team,
  LoyaltyProgram,
  Contact,
  Partnerships,
  SignIn,
  ForgotPassword,
  ResetPassword,
  BreastPump,
  Careers,
  MobileApp,
  TermsOfService,
  PrivacyPolicy,
  CorpGifting,
  Press,
  ErrorPage,
  Page404,
  Page403,
  Product,
  Review,
  Checkout,
  AdminPortalEntry,
  ShopRedirect,
  Blog,
  SelectSubscription,
  BreastPumpThankYou,
  CorporatePortal,
  CorporateVerification,
  PrenatalVitamins,
  CustomizeSubscription,
  CustomizeSubscriptionLandingPage,
  ViewRegistry,
  FindRegistry,
  ManageRegistry,
  CreateRegistry,
  Covid19,
  MyOrder,
  EditPayment,
  Giveaway,
  ReferAFriend,
  LifeInsurance,
  Extensions,
} from './splitRoutes';

import {
  AdminNav,
  Navigation,
  PartnershipNavigation,
  withTracker,
  WteFooter,
  PnmagFooter,
  Footer,
  UnskipBanner,
  UpdateCCBanner,
  ExtendSubscriptionBanner,
  VisibilityPlaceholder,
} from '../../components';

SentryService.initTime();

// Call once before the interval to get a new token on site load before any other requests are made
// TODO: Turn this code back on once refresh token cookie is working for all browsers
// if (Auth.hasToken()) {
//   BitsyApollo.refreshUserToken();
// }
// window.setInterval(() => {
//   // Fetch new token every 10 minutes
//   if (Auth.hasToken()) {
//     BitsyApollo.refreshUserToken();
//   }
// }, 1000 * 60 * 10);

class App extends React.Component {
  _isMounted = false; // eslint-disable-line no-underscore-dangle

  constructor(props) {
    super(props);
    this.state = {
      itemsInCart: 0,
      isCorporateUser: false,
      showFooter: false,
    };
    // Check for UTM values and store or replace them in certain conditions
    const urlParamString = window.location.search;
    const urlParams = new URLSearchParams(urlParamString);
    const storedUtmSource = localStorage.getItem('utm_source') || '';
    const storedUtmMedium = localStorage.getItem('utm_medium') || '';
    const storedUtmCampaign = localStorage.getItem('utm_campaign') || '';
    let storedUtmSetTime = localStorage.getItem('utmSetTime');
    if (storedUtmSetTime) {
      storedUtmSetTime = new Date(storedUtmSetTime);
    } else {
      storedUtmSetTime = new Date();
    }
    const eightHours = 8 * 60 * 60 * 1000;
    const eightHoursAgo = new Date(Date.now() - eightHours);
    if (
      storedUtmSetTime > eightHoursAgo &&
      urlParams.get('utm_source') === 'attentive' &&
      urlParams.get('utm_medium') === 'SMS' &&
      urlParams.get('utm_campaign').includes('welcome') &&
      (storedUtmSource.length ||
        storedUtmMedium.length ||
        storedUtmCampaign.length) &&
      !(
        storedUtmSource === 'attentive' &&
        storedUtmMedium === 'SMS' &&
        storedUtmCampaign.includes('welcome')
      )
    ) {
      urlParams.set('utm_source', storedUtmSource);
      urlParams.set('utm_medium', storedUtmMedium);
      urlParams.set('utm_campaign', storedUtmCampaign);
      window.location.search = urlParams.toString();
    } else if (
      urlParams.has('utm_source') ||
      urlParams.has('utm_medium') ||
      urlParams.has('utm_campaign')
    ) {
      localStorage.setItem('utm_source', urlParams.get('utm_source'));
      localStorage.setItem('utm_medium', urlParams.get('utm_medium'));
      localStorage.setItem('utm_campaign', urlParams.get('utm_campaign'));
      localStorage.setItem('utmSetTime', new Date().toString());
    }
  }

  async componentDidMount() {
    this._isMounted = true; // eslint-disable-line no-underscore-dangle
    this.onCartUpdate();

    localStorage.setItem('shouldShowPreCheckoutPromo', 'true');

    // MaxBounty check and storage
    const urlParamString = window.location.search;

    const urlParams = new URLSearchParams(urlParamString);

    if (urlParams.get('subid') && urlParams.get('clickid')) {
      localStorage.setItem('maxBountyClickId', urlParams.get('clickid'));
    }

    await this.getAndSetUser();

    await this.determineAndSetIsCorporateUser();

    this.runFacebookPixelInit();
  }

  componentWillUnmount() {
    this._isMounted = false; // eslint-disable-line no-underscore-dangle
  }

  setCorpPortLastAction = () => {
    localStorage.setItem('corpPortLastAction', new Date());
  };

  onLogIn = async () => {
    await this.getAndSetUser();
    await this.determineAndSetIsCorporateUser();
    await this.runFacebookPixelInit();
  };

  getAndSetUser = async (data) => {
    if (Auth.isLoggedIn()) {
      const user = await BitsyApollo.userInfoQuery(data);
      if (user && user.data && user.data.userInfo) {
        const userData = user.data.userInfo;
        this.setState({
          userData,
        });
      }
    }
  };

  determineAndSetIsCorporateUser = () => {
    if (this.state.userData && this.state.userData.accountType) {
      this.setState((prevState) => ({
        isCorporateUser: prevState.userData.accountType === 'corporate',
      }));
    }
  };

  runFacebookPixelInitOnload = async () => {
    const { isCorporateUser, userData } = this.state;
    let data;
    if (!isCorporateUser && userData && userData.name) {
      data = this.state.userData;
      await BBAnalytics.runTheInits(data);
    } else {
      await BBAnalytics.runTheInits();
    }
  };

  runFacebookPixelInit = async () => {
    if (window.addEventListener) {
      window.addEventListener('load', this.runFacebookPixelInitOnload, false);
    } else if (window.attachEvent) {
      window.attachEvent('onload', this.runFacebookPixelInitOnload);
    }
  };

  // Returning a function here is important.
  // It is what is being called when this method is called.
  // First time it's called, lastCall = 0.
  // Subsequent calls, lastCall is being set by the return function.
  // The return function is determining whether to call setCorpLastAction or not.
  throttleAction = (action, delay) => {
    let lastCall = 0;
    return () => {
      // eslint-disable-line func-names
      const now = new Date().getTime();
      if (now - lastCall < delay) {
        return null;
      }
      lastCall = now;
      return action();
    };
  };

  onCartUpdate = async () => {
    const customerId = localStorage.getItem('customerId');
    const hasToken = Auth.hasToken();
    const isLoggedIn = Auth.isLoggedIn();
    let itemsInCart;
    if (isLoggedIn || hasToken) {
      itemsInCart = await CartUtils.cartItemCountQuery(customerId);
    } else if (!isLoggedIn) {
      const tempCart = JSON.parse(localStorage.getItem('tempCart'));
      if (tempCart && (tempCart.productsAndDetails || tempCart.subscription)) {
        itemsInCart = tempCart.productsAndDetails.length;
        if (tempCart.subscription) {
          itemsInCart += 1;
        }
      } else {
        itemsInCart = 0;
      }
    }
    if (this._isMounted) this.setState({ itemsInCart }); // eslint-disable-line no-underscore-dangle
    return itemsInCart;
  };

  wrappedAdminPortalEntry = withTracker(AdminPortalEntry);

  wrappedSignIn = withTracker(SignIn, {
    onCartUpdate: this.onCartUpdate,
    onLogIn: this.onLogIn,
  });

  wrappedForgotPassword = withTracker(ForgotPassword);

  wrappedResetPassword = withTracker(ResetPassword);

  wrappedCorporateVerification = withTracker(CorporateVerification);

  wrappedPrenatalVitamins = withTracker(PrenatalVitamins, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedMyAccount = withTracker(MyAccount, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedSubscriptionDetails = withTracker(SubscriptionDetails);

  wrappedPaymentDetails = withTracker(PaymentDetails, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedDueDateCalculator = withTracker(DueDateCalculator);

  wrappedWeekByWeek = withTracker(WeekByWeek, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedSelectSubscription = withTracker(SelectSubscription, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedReview = withTracker(Review, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedHome = withTracker(Home, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedThankYou = withTracker(ThankYou, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedCheckout = withTracker(Checkout, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedFaq = withTracker(Faq);

  wrappedPartnerships = withTracker(Partnerships);

  wrappedAbout = withTracker(About);

  wrappedBumpFund = withTracker(BumpFund);

  wrappedTeam = withTracker(Team);

  wrappedPress = withTracker(Press);

  wrappedLoyaltyProgram = withTracker(LoyaltyProgram);

  wrappedContact = withTracker(Contact);

  wrappedCareers = withTracker(Careers);

  wrappedBreastPump = withTracker(BreastPump);

  wrappedMobileApp = withTracker(MobileApp);

  wrappedCovid19 = withTracker(Covid19);

  wrappedErrorPage = withTracker(ErrorPage);

  wrappedTermsOfService = withTracker(TermsOfService);

  wrappedPrivacyPolicy = withTracker(PrivacyPolicy);

  wrappedCorpGifting = withTracker(CorpGifting);

  wrappedPage403 = withTracker(Page403);

  wrappedBlog = withTracker(Blog);

  wrappedShop = withTracker(Shop, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedShopRedirect = withTracker(ShopRedirect, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedProduct = withTracker(Product, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedPage404 = withTracker(Page404);

  wrappedBreastPumpThankYou = withTracker(BreastPumpThankYou);

  wrappedCorporatePortal = withTracker(CorporatePortal, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedCustomizeSubscription = withTracker(CustomizeSubscription);

  wrappedCustomizeSubscriptionLandingPage = withTracker(
    CustomizeSubscriptionLandingPage,
  );

  wrappedViewRegistry = withTracker(ViewRegistry, {
    onCartUpdate: this.onCartUpdate,
  });

  wrappedFindRegistry = withTracker(FindRegistry);

  wrappedManageRegistry = withTracker(ManageRegistry);

  wrappedCreateRegistry = withTracker(CreateRegistry);

  wrappedMyOrder = withTracker(MyOrder);

  wrappedEditPayment = withTracker(EditPayment);

  wrappedGiveaway = withTracker(Giveaway);

  wrappedReferAFriend = withTracker(ReferAFriend);

  wrappedLifeInsurance = withTracker(LifeInsurance);

  wrappedExtensions = withTracker(Extensions);

  renderNavigation = () => {
    if (this.props.location.pathname.includes('/my-order')) {
      return null;
    }

    if (Environment.store !== 'bump' && Environment.store !== 'bitsy') {
      return <PartnershipNavigation itemsInCart={this.state.itemsInCart} />;
    }

    return (
      <>
        {this.state.userData ? (
          <div className='banner'>
            <UnskipBanner
              userData={this.state.userData}
              getAndSetUser={this.getAndSetUser}
            />
            <UpdateCCBanner
              userData={this.state.userData}
              getAndSetUser={this.getAndSetUser}
            />
            <ExtendSubscriptionBanner
              userData={this.state.userData}
              getAndSetUser={this.getAndSetUser}
            />
          </div>
        ) : null}
        <Navigation
          itemsInCart={this.state.itemsInCart}
          isCorporateUser={this.state.isCorporateUser}
        />
      </>
    );
  };

  renderFooter = () => {
    if (this.props.location.pathname.includes('/free-breast-pump')) {
      return null;
    }
    if (Environment.store === 'wtebump') {
      return <WteFooter />;
    }
    if (Environment.store === 'pnmbump') {
      return <PnmagFooter />;
    }
    return <Footer />;
  };

  onVisibilityFooter = (isVisible) => {
    if (isVisible && !this.state.showFooter) {
      this.setState({
        showFooter: true,
      });
    }
  };

  windowLocationPnm = () => {
    window.location = 'https://pnmag.bumpboxes.com';
    return null;
  };

  render() {
    // This Helmet tag defines the default meta tags to be served. It also
    // defines the title template to be followed by child pages.
    return (
      <div
        onMouseMove={
          this.state.isCorporateUser
            ? this.throttleAction(this.setCorpPortLastAction, 5000)
            : null
        }
      >
        <Helmet
          titleTemplate={`%s${Content.meta.defaultTitleSuffix}`}
          defaultTitle={
            Content.meta.defaultTitlePrefix + Content.meta.defaultTitleSuffix
          }
        >
          <meta name='description' content={Content.meta.defaultDescription} />
          <link
            rel='canonical'
            href={MetaTagService.getCanonicalUrl(this.props.location.pathname)}
          />
          <meta
            property='og:site_name'
            content={Content.names.fancyNamePlural}
          />
          <meta property='og:locale' content='en_US' />
          <meta property='og:type' content='website' />
          <meta
            property='og:title'
            content={MetaTagService.getTemplatedTitle(
              Content.meta.defaultTitlePrefix,
            )}
          />
          <meta
            property='og:description'
            content={Content.meta.defaultDescription}
          />
          <meta
            property='og:image'
            content={Content.names.mainUrl + Content.meta.defaultImg}
          />
          <meta
            property='og:url'
            content={MetaTagService.getCanonicalUrl(
              this.props.location.pathname,
            )}
          />

          <meta
            name='twitter:title'
            content={MetaTagService.getTemplatedTitle(
              Content.meta.defaultTitleSuffix,
            )}
          />
          <meta
            name='twitter:description'
            content={Content.meta.defaultDescription}
          />
          <meta
            name='twitter:image'
            content={Content.names.mainUrl + Content.meta.defaultImg}
          />
        </Helmet>
        {Auth.isAdmin() && !window.location.href.match(/admin-portal-entry/) ? (
          <AdminNav />
        ) : null}
        {Auth.isAdmin() && !window.location.href.match(/admin-portal-entry/) ? (
          <div className='admin-nav-placeholder' />
        ) : null}
        {this.renderNavigation()}
        {!this.props.location.pathname.includes('/my-order') ? (
          <div className='mobileTopPadding' />
        ) : null}
        <main>
          <Switch>
            <Route
              exact
              path='/admin-portal-entry/customer/:customerName/:customerId'
              component={this.wrappedAdminPortalEntry}
            />
            <Route exact path='/signin' component={this.wrappedSignIn} />
            <Route
              exact
              path='/forgot-password'
              component={this.wrappedForgotPassword}
            />
            <Route
              exact
              path='/legacy/reset-password/:resetPasswordCode'
              component={this.wrappedResetPassword}
            />
            <Route
              exact
              path='/reset-password/:resetPasswordCode'
              component={this.wrappedResetPassword}
            />
            <Route exact path='/my-account' component={this.wrappedMyAccount} />
            <Route
              exact
              path='/subscription-details/:subscriptionId'
              component={this.wrappedSubscriptionDetails}
            />
            <Route
              exact
              path='/payment-details/:subscriptionId'
              component={this.wrappedPaymentDetails}
            />

            <Route
              exact
              path='/due-date-calculator'
              component={this.wrappedDueDateCalculator}
            />
            <Route
              exact
              path='/week-by-week'
              component={this.wrappedWeekByWeek}
            />
            <Route
              exact
              path='/week-by-week/:week'
              component={this.wrappedWeekByWeek}
            />
            <Route
              exact
              path='/subscribe/select'
              component={this.wrappedSelectSubscription}
            />
            <Route
              exact
              path='/gift'
              component={this.wrappedSelectSubscription}
            />
            <Route
              exact
              path='/purchase/thank-you/:purchaseId'
              component={this.wrappedThankYou}
            />
            <Route
              exact
              path='/guest/checkout/review'
              component={this.wrappedReview}
            />
            <Route
              exact
              path='/checkout/review'
              component={this.wrappedReview}
            />
            <Route
              exact
              path='/checkout/shipping-and-payment'
              component={this.wrappedCheckout}
            />
            <Route exact path='/' component={this.wrappedHome} />
            <Route exact path='/membership' component={this.wrappedHome} />
            <Route exact path='/mb' component={this.wrappedHome} />
            <Route
              exact
              path='/referred/:referralCode'
              component={this.wrappedHome}
            />
            <Route exact path='/faq' component={this.wrappedFaq} />
            <Route
              exact
              path='/partnerships'
              component={this.wrappedPartnerships}
            />
            <Route exact path='/about-us' component={this.wrappedAbout} />
            <Route exact path='/bump-fund' component={this.wrappedBumpFund} />
            <Route exact path='/team' component={this.wrappedTeam} />
            <Route exact path='/press' component={this.wrappedPress} />
            <Route
              exact
              path='/loyalty-program'
              component={this.wrappedLoyaltyProgram}
            />
            <Route exact path='/contact' component={this.wrappedContact} />
            <Route exact path='/careers' component={this.wrappedCareers} />
            <Route
              exact
              path='/baby-name-matcher'
              component={this.wrappedMobileApp}
            />
            <Route exact path='/covid19' component={this.wrappedCovid19} />
            <Route exact path='/error' component={this.wrappedErrorPage} />
            <Route
              exact
              path='/terms-of-service'
              component={this.wrappedTermsOfService}
            />
            <Route
              exact
              path='/privacy-policy'
              component={this.wrappedPrivacyPolicy}
            />
            <Route
              exact
              path='/corporate-gifting'
              component={this.wrappedCorpGifting}
            />
            <Route
              exact
              path='/error/unauthorized'
              component={this.wrappedPage403}
            />
            <Route exact path='/index.html' component={this.wrappedHome} />
            <Route exact path='/review' component={this.wrappedReview} />
            <Route path='/blog/post/:blogName' component={this.wrappedBlog} />
            <Route path='/blog/page/:pageNumber' component={this.wrappedBlog} />
            <Route
              path='/blog/category/:category'
              component={this.wrappedBlog}
            />
            <Redirect
              from='/labor-of-love-box*'
              to='/products/labor-of-love-box'
            />
            <Redirect from='/gift-subscription' to='/' />
            <Redirect from='/check-out' to='/shop/all' />

            <Route exact path='/blog/' component={this.wrappedBlog} />
            <Route exact path='/blog' component={this.wrappedBlog} />
            <Route exact path='/pnmag/' component={this.windowLocationPnm} />
            <Route exact path='/pnmag' component={this.windowLocationPnm} />

            <Redirect from='/peoria*' to='/careers' />

            {Environment.store === 'bump'
              ? [
                  <Route
                    exact
                    path='/prenatal-vitamins'
                    key='/prenatal-vitamins'
                    component={this.wrappedPrenatalVitamins}
                  />,
                  <Redirect
                    from='/free-prenatal-vitamins'
                    key='/free-prenatal-vitamins'
                    to='/prenatal-vitamins'
                  />,
                  <Redirect
                    from='/prenatals'
                    key='/prenatals'
                    to='/prenatal-vitamins'
                  />,
                  <Route
                    exact
                    path='/view-registry/:shareCode'
                    key='/view-registy/:shareCode'
                    component={this.wrappedViewRegistry}
                  />,
                  <Route
                    exact
                    path='/find-registry'
                    key='/find-registy'
                    component={this.wrappedFindRegistry}
                  />,
                  <Route
                    exact
                    path='/manage-registry'
                    key='/manage-registy'
                    component={this.wrappedManageRegistry}
                  />,
                  <Route
                    exact
                    path='/create-registry'
                    key='/create-registy'
                    component={this.wrappedCreateRegistry}
                  />,
                ]
              : null}

            {Environment.store === 'bump'
              ? [
                  <Route
                    exact
                    path='/free-breast-pump/thank-you'
                    key='/free-breast-pump/thank-you'
                    component={this.wrappedBreastPumpThankYou}
                  />,
                  <Route
                    exact
                    path='/free-breast-pump/:step'
                    key='/free-breast-pump/:step'
                    component={this.wrappedBreastPump}
                  />,
                  <Redirect
                    from='/free-breast-pump'
                    key='/free-breast-pump'
                    to='/free-breast-pump/step-1'
                  />,
                  <Redirect
                    from='/pump'
                    key='/pump'
                    to='/free-breast-pump/step-1'
                  />,
                  <Redirect
                    from='/pumps'
                    key='/pumps'
                    to='/free-breast-pump/step-1'
                  />,
                ]
              : null}

            {Environment.store === 'bump' || Environment.store === 'bitsy'
              ? [
                  <Route
                    exact
                    path='/shop/:parentCategory'
                    key='/shop/:parentCategory'
                    component={this.wrappedShopRedirect}
                  />,
                  <Route
                    exact
                    path='/shop/:parentCategory/:childCategory'
                    key='/shop/:parentCategory/:childCategory'
                    component={this.wrappedShopRedirect}
                  />,
                  <Route
                    exact
                    path='/shop/:parentCategory/:childCategory/:sort'
                    key='/shop/:parentCategory/:childCategory/:sort'
                    component={this.wrappedShopRedirect}
                  />,
                  <Redirect from='/shop/' to='/shop/all' key='/shop/' />,
                  <Redirect from='/shop' to='/shop/all' key='/shop' />,
                  <Route
                    exact
                    path='/product-category/:oldBumpCategory'
                    key='/product-category/:oldBumpCategory'
                    component={this.wrappedShopRedirect}
                  />,
                  <Route
                    exact
                    path='/product-category/shop-all-products'
                    key='/product-category/shop-all-products'
                    component={this.wrappedShop}
                  />,
                  <Route
                    exact
                    path='/products/:productUrlName'
                    key='/products/:productUrlName'
                    component={this.wrappedProduct}
                  />,
                  <Route
                    exact
                    path='/product/:productUrlName'
                    key='/product/:productUrlName'
                    component={this.wrappedProduct}
                  />,
                  <Route
                    exact
                    path='/portal/:companyCode'
                    key='/portal/:companyCode'
                    component={this.wrappedCorporatePortal}
                  />,
                  <Route
                    exact
                    path='/signup/:signUpCode'
                    key='/signup/:signUpCode'
                    component={this.wrappedSignIn}
                  />,
                  <Route
                    exact
                    path='/corporate-verification/:corporateVerificationCode'
                    key='/corporate-verification/:corporateVerificationCode'
                    component={this.wrappedCorporateVerification}
                  />,
                  <Route
                    exact
                    path='/customize-subscription/:subscriptionId'
                    key='/customize-subscription/:subscriptionId'
                    component={this.wrappedCustomizeSubscription}
                  />,
                  <Route
                    exact
                    path='/customize-subscription'
                    key='/customize-subscription'
                    component={this.wrappedCustomizeSubscriptionLandingPage}
                  />,
                ]
              : null}
            <Route
              path='/my-order/:confirmationCode'
              component={this.wrappedMyOrder}
            />
            <Route
              path='/edit-payment/:subConfirmationCode'
              component={this.wrappedEditPayment}
            />
            <Route path='/giveaway' component={this.wrappedGiveaway} />
            <Route
              path='/refer-a-friend'
              component={this.wrappedReferAFriend}
            />
            <Route
              path='/life-insurance'
              component={this.wrappedLifeInsurance}
            />
            <Route path='/extensions' component={this.wrappedExtensions} />
            <Route component={this.wrappedPage404} />
          </Switch>
        </main>
        <VisibilitySensor
          offset={{ top: 25 }}
          partialVisibility
          onChange={this.onVisibilityFooter}
          active={!this.state.showFooter}
        >
          {this.state.showFooter ? (
            <footer>{this.renderFooter()}</footer>
          ) : (
            <VisibilityPlaceholder />
          )}
        </VisibilitySensor>
      </div>
    );
  }
}

export default withRouter(App);
